import React, { useContext } from "react";
import noImage from "../../../../Assets/Images/settings/no-image.png";
import retangle from "../../../../Assets/Images/Rounds/retangle.png";
import tri from "../../../../Assets/Images/shakib_Khan.jpg";
import "./JudgeCom.css";
import { serverInfo } from "../../../../App";

const JudgeCom = ({ audition }) => {
  const { imageCdnUrl } = useContext(serverInfo);

  return (
    <div className="card bg-dark">
      <div className="card-body">
        <h4 className="text-warning">Audition judges</h4>
        <div style={{ borderTop: "2px solid black" }}></div>

        <div className="h3 text-center text-warning my-4">
          Who will judge you?
        </div>

        <div className="row">
          {audition &&
            audition.assigned_judges?.map((judge) => (
              <div className="col-md-4 col-lg-4 mb-3 ">
                <div className="card judge-bg rounded-3">
                  <div className="text-center p-4">
                    <img
                      src={
                        judge.user?.image != null
                          ? imageCdnUrl + judge.user?.image
                          : noImage
                      }
                      className="img-fluid rounded-circle img-box my-3"
                      alt=""
                    />
                  </div>

                  <div
                    className="judgeretangle"
                    style={{ position: "relative" }}
                  >
                    <img src={retangle} alt="" className="img-fluid" />

                    <div className="row align-items-center judge-content">
                      <h6 className="text-light text-center star-title-judge">
                        Super Star
                      </h6>
                      <h6 className="text-light text-center fw-bold star-title-name-judge">
                        {judge.user?.first_name + " " + judge.user?.last_name}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>

        <div className="h3 text-center text-warning mt-3 mb-3">
          Incretibles Jury wainting for you
        </div>
        <div style={{ borderTop: "2px solid black" }}></div>

        <div className="row my-3">
          {audition &&
            audition.assigned_juries?.map((jury) => (
              <div className="col-6 col-md-3 my-2">
                <div className="card" style={{ backgroundColor: "black" }}>
                  <div className="card-body">
                    <div className="text-center my-3 img-jury">
                      <img
                        src={
                          jury.user?.image != null
                            ? imageCdnUrl + jury.user?.image
                            : noImage
                        }
                        className="img-fluid"
                        style={{
                          height: "70px",
                          width: "70px",
                          borderRadius: "50%",
                          border: "2px solid gold",
                        }}
                        alt=""
                      />
                    </div>
                    <h5 className="text-light text-center title-name-jury">
                      {jury.user?.first_name + " " + jury.user?.last_name}
                    </h5>
                    <h6 className="text-light text-center">
                      {jury.user?.starCategory?.name}
                    </h6>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default JudgeCom;
